<template>
    <div class="other-panel iphone-x-fit"
        ref="otherPanel"
        v-show="isShow">
        <div class="other">
            <div class="other__item"
                :class="{
                    [`other__item--${item.name}`]: true
                }"
                v-for="(item, index) in otherList"
                :key="index"
                :title="item.title">
                <van-uploader
                    :name="item.name"
                    :accept="item.acceptString"
                    :max-count="item.maxCount"
                    :before-read="beforeRead"
                    :after-read="afterRead">
                    <div class="other__icon">
                        <i :class="{
                            [item.icon]: true
                        }"></i>
                    </div>
                    <div class="other__name"
                        v-if="isMobile">{{item.text}}</div>
                </van-uploader>
            </div>
        </div>
    </div>
</template>

<script>
    import { TRIGGER_CLICK_OTHER_PANEL_ITEM } from '@/constants/pub_sub'
    import {
        isValidFileType,
        isValidFileSize,
        UPLOAD_MAX_COUNT,
        UPLOAD_ACCEPT_TYPE_IMAGE,
        UPLOAD_ACCEPT_TYPE_FILE,
        UPLOAD_ACCEPT_TYPE_VIDEO,
        getFileSuffix,
        UPLOAD_ACCEPT_TYPE_IMAGE_SUFFIX,
        UPLOAD_ACCEPT_TYPE_VIDEO_SUFFIX,
        UPLOAD_ACCEPT_TYPE_FILE_SUFFIX,
        UPLOAD_ACCEPT_TYPE_AUDIO_SUFFIX,
    } from '@/utils/upload'
    import {
        uploadFileBusiness,
        uploadImgBusiness
    } from '../../utils/upload_business'
    const processAccept = (accepts) => {
        if (!accepts.length) return ''
        return accepts.map(item => `${item[0] === '.' ? item : `.${item}`}`).join(',')
    }

    export default {
        name: 'TheOtherPanel',
        props: {
            isShow: {
                type: Boolean,
                required: true
            }
        },
        computed: {
            isMobile () {
                return this.$eventBus.isMobile
            },
            otherList () {
                return [
                    {
                        icon: 'icon_file',
                        name: 'file',
                        text: '文件',
                        title: '请上传文件',
                        accept: UPLOAD_ACCEPT_TYPE_FILE,
                        suffixAccept: [...UPLOAD_ACCEPT_TYPE_FILE_SUFFIX, ...UPLOAD_ACCEPT_TYPE_AUDIO_SUFFIX],
                        acceptString: processAccept(UPLOAD_ACCEPT_TYPE_FILE),
                        maxCount: UPLOAD_MAX_COUNT
                    },
                    {
                        icon: 'icon_photo',
                        name: 'photo',
                        text: '图片',
                        title: '请上传图片',
                        accept: UPLOAD_ACCEPT_TYPE_IMAGE,
                        suffixAccept: UPLOAD_ACCEPT_TYPE_IMAGE_SUFFIX,
                        acceptString: processAccept(UPLOAD_ACCEPT_TYPE_IMAGE_SUFFIX),
                        maxCount: UPLOAD_MAX_COUNT
                    },
                    {
                        icon: 'icon_video',
                        name: 'video',
                        text: '视频',
                        title: '请上传视频',
                        accept: UPLOAD_ACCEPT_TYPE_VIDEO,
                        suffixAccept: UPLOAD_ACCEPT_TYPE_VIDEO_SUFFIX,
                        acceptString: processAccept(UPLOAD_ACCEPT_TYPE_VIDEO_SUFFIX),
                        maxCount: UPLOAD_MAX_COUNT
                    }
                ]
            }
        },
        methods: {
            /**
             * @param { File } file
             * @param { Object } detail
             * @param { String } detail.name
             * @returns { Boolean }
             */
            beforeRead (file, { name }) {
                const config = this.otherList.find(item => item.name === name)
                if (!isValidFileType(getFileSuffix(file.name), config.suffixAccept)) {
                    // 其实对于 name = file，无文件类型限制
                    this.$toast('不支持该文件格式')
                    return false
                }
                const validFileSizeErrorString = isValidFileSize(file, file.size)
                if (validFileSizeErrorString) {
                    this.$toast.fail(validFileSizeErrorString)
                    return false
                }
                return true
            },
            /**
             * @param { Object } file
             * @param { File } file.file
             * @param { String } file.content - base64
             * @param { Object } detail
             * @param { String } detail.name
             * @param { Number } detail.index
             */
            async afterRead ({ file }, { name }) {
                if (name === 'file' || name === 'video') {
                    uploadFileBusiness(file)
                } else if (name === 'photo') {
                    uploadImgBusiness(file)
                }
                this.$emit('closeAllPanel')
            }
        },

        mounted () {
            this.$eventBus.$on(TRIGGER_CLICK_OTHER_PANEL_ITEM, itemName => {
                const otherPanelRef = this.$refs.otherPanel
                const ref = otherPanelRef.querySelector(`.other__item--${itemName} input[type=file]`)
                if (ref) {
                    ref.click()
                }
            })
        },
        beforeDestroy () {
            this.$eventBus.$off(TRIGGER_CLICK_OTHER_PANEL_ITEM)
        }
    }
</script>

<style lang="scss" scoped>
    .other-panel {
        overflow: auto;
        height: 120px;
        background-color: #FAFBFD;
        border-top: 1px solid #F4F4F6;
    }
    .other {
        display: flex;
        align-items: center;
        height: 100%;
        padding: 0 percent(40);
        overflow: auto;

        @at-root .is-desktop & {
            padding-top: percent(11);
        }

        &__item {
            display: inline-flex;
            align-items: center;
            flex-direction: column;
            width: 36px;

            &:nth-child(n + 2) {
                margin-left: percent(40);
            }
        }

        &__icon {
            width: 100%;

            i {
                font-size: 36px;
                line-height: 1;
            }
        }

        &__name {
            font-size: 12px;
            line-height: 1;
            color: $primary-text-color;
            text-align: center;
            margin-top: 10px;
        }

        /deep/ .van-uploader,
        /deep/ .van-uploader__input-wrapper {
            width: 100%;
        }
    }
</style>
